import { render, staticRenderFns } from "./VistaDetalle.vue?vue&type=template&id=59942de0&scoped=true"
import script from "./VistaDetalle.vue?vue&type=script&lang=js"
export * from "./VistaDetalle.vue?vue&type=script&lang=js"
import style0 from "./VistaDetalle.vue?vue&type=style&index=0&id=59942de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59942de0",
  null
  
)

export default component.exports